module.exports = __webpack_public_path__ + "media/images/ui-onboard/responsive-bd258313273c159e408880a71e636fa1.svg";